import { useEffect } from "react";

export default function HomePage() {
  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <div className="h-screen flex items-center justify-center overflow-hidden">
      <h1 className="text-[320px] text-center font-bold mt-6">blpnt</h1>
    </div>
  );
}
